import { store } from "../store/index";
import {
  filterArticle,
  removeArticle,
  modifyArticle,
  getArticleByUuid,
  createArticle,
  getAll,
} from "../store/actions/ArticleActions";

/**
 * Create Article
 */
export const addArticle = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createArticle(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Article
 */
export const getArticle = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getArticleByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Article
 */
export const updateArticle = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyArticle(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Article
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterArticle(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Article
 */
export const deleteArticle = async (uuid) => {
  const result = await store.dispatch(removeArticle([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Get all articles
 */
export const getAllArticles = async (filters = {}) => {
  const result = await store.dispatch(getAll(filters));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
